import $okgportal_api from "@/shared/client/okgportal.client";
import { BaseOkgportalResponce } from "@/shared/model/api.types";
import { CompanyTargetInterface, MultyPlanInterface, MultyPlanResultInterface, PlanInterface, PlanResponse } from "../model/plan.types";
import { CreatePlanPopupForm } from "@/features/Sale/HeaderDashboard/components/_popups/CreatePlanPopup/CreatePlanPopup.model";
import { CreateCompanysPlanForm } from "@/features/Sale/HeaderDashboard/components/_popups/CreateCompanysPlanPopup/CreateCompanysPlanPopup.model";
import { EditCompanysPlanFormInterface, EditPlanFormInterface } from "@/features/Sale/HeaderDashboard/components/_popups/EditPlanPopup/EditPlanPopup.model";

class PlanApi{
  async getMyPlans(){
    try {
      const response = await $okgportal_api.get<BaseOkgportalResponce<PlanInterface[] | null>>('/plan/my');
      return response.data
    } catch (error) {
      throw error
    }
  }

  async getMyMultyPlans(){
    try {
      const response = await $okgportal_api.get<BaseOkgportalResponce<MultyPlanInterface[] | null>>('/plan/myMulty');
      return response.data
    } catch (error) {
      throw error
    }
  }

  async getResultUserPlans(data: {dateStart: string, dateEnd: string}, user_id: number){
    try {
      const response = await $okgportal_api.post<BaseOkgportalResponce<PlanResponse>>(`/plan/resultUserPlans/${user_id}`, data);
      return response.data;
    } catch (error) {
      throw error
    }
  }

  async createPlan(data: CreatePlanPopupForm){
    try {
      const response = await $okgportal_api.post<BaseOkgportalResponce<PlanInterface>>('/plan', data);
      return response.data
    } catch (error) {
      throw error
    }
  }

  async update(data: EditPlanFormInterface){
    try {
      const response = await $okgportal_api.patch<BaseOkgportalResponce<PlanInterface>>('/plan', data);
      return response.data
    } catch (error) {
      throw error
    }
  }

  async updateMyltyPlan(data: EditCompanysPlanFormInterface){
    try {
      const response = await $okgportal_api.patch<BaseOkgportalResponce<MultyPlanResultInterface>>('/plan/multy', data);
      return response.data
    } catch (error) {
      throw error
    }
  }

  async delete(id: number){
    try {
      const response = await $okgportal_api.delete<BaseOkgportalResponce<PlanInterface>>(`/plan/${id}`);
      return response.data
    } catch (error) {
      throw error
    }
  }

  async deleteMulty(id: number){
    try {
      const response = await $okgportal_api.delete<BaseOkgportalResponce<PlanInterface>>(`/plan/mullty/${id}`);
      return response.data
    } catch (error) {
      throw error
    }
  }

  async createMyltyPlan(data: CreateCompanysPlanForm){
    try {
      const response = await $okgportal_api.post<BaseOkgportalResponce<MultyPlanResultInterface>>('/plan/multy', data);
      return response.data
    } catch (error) {
      throw error
    }
  }
}
const planApi = new PlanApi();
export default planApi;